import { axiosClient } from "@/shared/api/axios-client";
import { encolarDescarga } from "@/shared/api/descarga-secuencial";

/**
 * Descarga el PDF de la factura extranjera (subtipo Invoice) de una solicitud.
 * El PDF no es un documento vinculado — vive en el storage bajo la solicitud —,
 * así que tiene su propio endpoint. El nombre real llega en `Content-Disposition`.
 * SECUENCIAL (cola global de descargas · misma convención que documentos/facturas).
 */
export async function descargarInvoicePdf(solicitudId: string): Promise<void> {
  const resp = await encolarDescarga(() =>
    axiosClient.get<Blob>(`/api/invoice/${solicitudId}/pdf`, { responseType: "blob" }),
  );
  const disposition = String(resp.headers["content-disposition"] ?? "");
  const match = /filename="?([^";]+)"?/.exec(disposition);
  const filename = match?.[1] ?? `invoice_${solicitudId}.pdf`;
  const blob = new Blob([resp.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
